import cx from 'classnames'
import Form from 'react-bootstrap/Form'
import Typography from '../../Typography/Typography'

import './FormLayout.scss'

const FormLayout = ({ title, children, onSubmit, className, size = 'md', color = 'blue' }) => {
    return (
        <Form
            noValidate
            onSubmit={onSubmit}
            className={cx(`form-layout form-layout--${color} form-layout--${size}`, className)}
        >
            {title && (
                <Typography variant={'h2'} className={'form-layout--title'}>
                    {title}
                </Typography>
            )}
            {children}
        </Form>
    )
}

export default FormLayout
